import React from 'react'
import styled from 'styled-components'

import Icon from '~/truck/icon'
import theme from '~/truck/theme'

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${theme.spacing.cozy}px;
`

const Header = props => {
  const { onClose } = props

  return (
    <Container>
      <Icon color="black30" onClick={onClose} type="close" size="md" />
    </Container>
  )
}

export default Header
